import { useContext, useEffect, useState } from "react";

import { LuFileMinus, LuFilePenLine, LuMailWarning } from "react-icons/lu";
import { BiDevices } from "react-icons/bi";
import { AiOutlineNotification } from "react-icons/ai";
import { GiCheckMark } from "react-icons/gi";
import { DContext } from "../../context/Datacontext";

export const Notification = () => {
    const { handleNotification, getNotification, currentUser, notificationReadAction, notificationReadActionAll } = useContext(DContext);
    const [popupNotification, setPopupNotification] = useState(null)
    const [popup, setPopup] = useState(false)
    const [perPage, setPerPage] = useState(5)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [totalCount, setTotalCount] = useState(1)

    const fetchNotification = () => handleNotification(perPage, currentPage, setTotalPages, setTotalCount)

    useEffect(() => {
        fetchNotification()
    }, []);


    useEffect(() => {
        fetchNotification()
    }, [perPage, currentPage]);

    const getIcon = (type, extraClass = "") => {
        switch (type) {
            case "job-application":
                return <LuFileMinus className={`${extraClass} text-xl`} />;
            case "application-status":
                return <LuFilePenLine className={`${extraClass} text-xl`} />;
            case "system-alert":
                return <LuMailWarning className={`${extraClass} text-xl`} />;
            case "device-status":
                return <BiDevices className={`${extraClass} text-xl`} />
            default:
                return <AiOutlineNotification className={`${extraClass} text-xl`} />;
        }
    };

    const handleAction = (id) => {
        notificationReadAction(id)
    };

    const handleReadAllAction = (id) => {
        notificationReadActionAll(id)
    }

    const handleViewAction = (id) => {
        if (!id) return;
        const viewPopupNotificationInfo = getNotification.find(item => item?._id === id);
        if (viewPopupNotificationInfo) {
            setPopupNotification(viewPopupNotificationInfo);
            setPopup(true);
        } else {
            setPopupNotification("No data available");
        }
    };



    return (
        <div className="py-6 min-h-[70vh] bg-[#F8F8F8]">
            {/* Heading */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-lg font-semibold">My Notifications</h2>
                    <p className="text-sm text-gray-500">
                        Track job applications, support updates, and platform alerts in real-time.
                    </p>
                </div>
                <button type="button" onClick={() => handleReadAllAction(currentUser?._id)}
                    onTouchStart={() => handleReadAllAction(currentUser?._id)} className={`text-primary-600 font-semibold text-sm hover:underline ${getNotification.some(item => !item?.isRead) ? "cursor-pointer" : "cursor-not-allowed"}`}
                    disabled={getNotification.every(item => item?.isRead)}
                >
                    {getNotification?.length > 0 &&
                        getNotification.some(item => !item?.isRead) && (
                            <>
                                Mark All as Read
                                <div className="inline-flex items-center gap-1 bg-primary-600/10 px-1 rounded-full ml-3">
                                    <span className="text-red-500 font-bold text-sm">
                                        {getNotification.filter(item => !item?.isRead).length}
                                    </span>
                                    /
                                    <span className="text-blue-500 font-bold text-sm">
                                        {getNotification.length}
                                    </span>
                                </div>

                            </>
                        )}
                </button>

            </div>






            <div className="w-full overflow-auto">
                <table className="w-full border-spacing-y-1 border-separate">
                    <thead>
                        <tr className="text-secondary-400">
                            <th className="py-3 px-2 rounded-l-xl bg-purple-100">Title</th>
                            <th className="py-3 px-2 bg-purple-100 hidden md:table-cell">Message</th>
                            <th className="py-3 px-2 bg-purple-100 hidden md:table-cell">Type</th>
                            <th className="py-3 px-2 bg-purple-100 hidden md:table-cell">Time</th>
                            <th className="py-3 px-2 rounded-r-xl bg-purple-100">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            getNotification.length > 0 ?
                                getNotification.map((notify, i) => (
                                    <tr className={`text-sm ${notify?.isRead ? "text-gray-400" : "font-semibold"}`} key={i}>
                                        <td className="py-3 px-2 rounded-l-xl bg-white" title={notify?.description || "No Data"}>
                                            <div className="flex items-center gap-2">
                                                <span className="text-primary-300 capitalize">{getIcon(notify?.type, `${!notify?.isRead ? "text-primary-300" : "text-gray-400"}`)}</span>
                                                <span className="line-clamp-2">{notify?.title || "N/A"}</span>
                                            </div>
                                        </td>
                                        <td className="py-3 px-2 bg-white hidden md:table-cell" title={notify?.description || "No Data"}>
                                            <p className="line-clamp-2">{notify?.description || "N/A"}</p>
                                        </td>
                                        <td className="py-3 px-2 bg-white hidden md:table-cell">
                                            <p className="line-clamp-2">{notify?.type || "N/A"}</p>
                                        </td>
                                        <td className="py-3 px-2 bg-white hidden md:table-cell">
                                            <p className="line-clamp-2">
                                                {new Date(notify?.createdAt).toLocaleString("en-IN", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true
                                                }) || "N/A"}
                                            </p>
                                        </td>
                                        <td className="py-3 px-2  rounded-r-xl bg-white">
                                            <div className="flex gap-2 justify-center items-center flex-wrap sm:flex-nowrap">
                                                <button
                                                    className="px-4 py-1 bg-blue-500 text-white text-xs rounded-lg shadow-md hover:bg-blue-600 transition"
                                                    onClick={() => handleViewAction(notify?._id)}
                                                    onTouchStart={() => handleViewAction(notify?._id)}
                                                >
                                                    View
                                                </button>


                                                <button
                                                    type="button"
                                                    className={`px-4 py-1 font-medium text-xs rounded-lg shadow-md transition-all duration-200
                                                    ${notify?.isRead
                                                            ? 'bg-gray-500 hover:bg-gray-400 active:scale-95 text-gray-100'
                                                            : 'bg-red-50 hover:bg-red-500 active:scale-95 text-red-500 hover:text-white'}`}
                                                    onClick={() => handleAction(notify?._id)}
                                                    onTouchStart={() => handleAction(notify?._id)}
                                                    disabled={notify?.isRead}
                                                >
                                                    {
                                                        notify?.isRead ?
                                                            "Read" :
                                                            <span className="flex items-center gap-1 justify-center">
                                                                <GiCheckMark />
                                                                Read
                                                            </span>
                                                    }
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                :
                                <tr>
                                    <td colSpan={5}>
                                        <div className="py-6 px-2 flex justify-center items-center">
                                            <p className="text-gray-500 text-sm">No notifications found</p>
                                        </div>
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>


            <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3">

                <div className="flex items-center justify-center gap-3 flex-1">
                    <label className="text-sm">Items per page</label>
                    <select value={perPage} onChange={e => setPerPage(e.target.value)} className="border rounded-lg px-3 py-1 text-xs">
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                <div className="flex items-center justify-center gap-2 flex-1">
                    <button
                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                        disabled={currentPage <= 1}
                        className={`px-3 py-1 text-xs rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Prev
                    </button>

                    {currentPage} of {totalPages || 1}

                    <button
                        onClick={() => setCurrentPage(((currentPage + 1) > totalPages) ? totalPages : currentPage + 1)}
                        disabled={currentPage >= (totalPages || 1)}
                        className={`px-3 py-1 text-xs rounded-lg border ${currentPage >= (totalPages || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Next
                    </button>
                </div>

                <div className="text-sm text-slate-600 flex-1 text-center">
                    Total {totalCount || 0} result{totalCount <= 1 ? "" : "s"}
                </div>

            </div>



            {popup && popupNotification && (
                <div className="fixed inset-0 bg-white/5 backdrop-blur-sm flex justify-center items-center z-50">
                    <div className="bg-white rounded-xl shadow-2xl w-[420px] max-w-[95%] animate-fadeIn">
                        {/* Header */}
                        <div className="bg-gradient-to-r from-primary-300 to-purple-400 text-white rounded-t-xl px-6 py-4">
                            <h3 className="text-lg font-semibold">
                                {popupNotification.title}
                            </h3>
                        </div>

                        {/* Body */}
                        <div className="p-6 space-y-4">
                            <ul className="list-disc list-inside text-gray-700 space-y-1">
                                <li><strong>Description:</strong> {popupNotification.description}</li>
                                <li><strong>Type:</strong> {popupNotification.type}</li>
                                <li><strong>Time:</strong> {new Date(popupNotification.createdAt).toLocaleString()}</li>
                            </ul>
                        </div>

                        {/* Footer */}
                        <div className="px-6 py-2 border-t flex justify-end">
                            <button
                                onClick={() => setPopup(false)}
                                className="px-4 py-1 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all"
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
